export default class StaffCredit {
    constructor(el) {
        this.element        = el;
        this.buttons        = this.element.querySelectorAll('[data-button]');
        this.slideWrappers  = this.element.querySelectorAll('[data-wrapper]');

        this.buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                let direction       = button.getAttribute('data-button');
                let currentSlide    = button.getAttribute('data-slide');
                this.changeSlide(direction, currentSlide);
            });
        });

    }

    changeSlide(direction, currentSlide) {
        let nextSlide = currentSlide;
        if(direction === 'next') {
            nextSlide++;
            if(nextSlide > this.slideWrappers.length) {
                nextSlide = 1;
            }
        } else {
            nextSlide--;
            if(nextSlide === 0) {
                nextSlide = this.slideWrappers.length;
            }
        }

        currentSlide--
        nextSlide--
        this.slideWrappers[currentSlide].removeAttribute('data-visible');
        this.slideWrappers[nextSlide].dataset.visible = "";
    }
}
